<div class="flex justify-center mobile:px-5 laptop:px-8 overflow-y-auto" *ngIf="branding">
  <div class="pt-5 w-343 tablet:w-768 laptop:w-912 tablet:px-6" *ngIf="meeting">
    <interview-details-confirmed
      *ngIf="meeting.status == InterviewStatus.ACCEPTED"
      [meeting]="meeting"
      [interviewers]="interviewers"
      [dashboardInfo]="dashboardInfo$ | async"
      (onBackButtonClicked)="backToDashboard()"
      (onDeclineInterviewClicked)="meeting.bookingType === BookingType.GROUP ? declineGroupInterview($event, true) : declineInterview($event)"
      (onAddToCalendarClicked)="downloadFile($event)"
    ></interview-details-confirmed>
    <interview-details-individual-specific
      *ngIf="meeting.status != InterviewStatus.ACCEPTED && meeting.bookingType == BookingType.INDIVIDUALSPECIFIC"
      [meeting]="meeting"
      [interviewers]="interviewers"
      [dashboardInfo]="dashboardInfo$ | async"
      (onBackButtonClicked)="backToDashboard()"
      (onConfirmInterviewClicked)="confirmInterview($event)"
      (onDeclineInterviewClicked)="declineInterview($event)"
    ></interview-details-individual-specific>
    <interview-details-individual-select
      *ngIf="meeting.status != InterviewStatus.ACCEPTED && meeting.bookingType == BookingType.INDIVIDUALSELECT"
      [meeting]="meeting"
      [interviewers]="interviewers"
      [dashboardInfo]="dashboardInfo$ | async"
      (onBackButtonClicked)="backToDashboard()"
      (onDeclineInterviewClicked)="declineInterview($event)"
      (onSlotSelected)="selfSelectSlot($event)"
    ></interview-details-individual-select>
    <interview-details-group
      *ngIf="meeting.status != InterviewStatus.ACCEPTED && meeting.bookingType == BookingType.GROUP"
      [groupMeetingSlots]="groupMeetingSlots"
      [meeting]="meeting"
      [interviewers]="interviewers"
      [dashboardInfo]="dashboardInfo$ | async"
      (onBackButtonClicked)="backToDashboard()"
      (onConfirmInterviewClicked)="confirmGroupInterview($event)"
      (onDeclineInterviewClicked)="declineGroupInterview($event)"
    ></interview-details-group>
  </div>
</div>
